export const cilAirplay = ["24 24","<path d='M21.75 2.203h-19.5c-0.828 0-1.5 0.672-1.5 1.5v0 13.922c0 0.828 0.672 1.5 1.5 1.5v0h3.584l1.167-1.5h-4.75v-13.922h19.5v13.922h-4.75l1.167 1.5h3.584c0.828 0 1.5-0.672 1.5-1.5v0-13.922c0-0.828-0.672-1.5-1.5-1.5v0z'></path><path d='M4.633 23.25h14.735l-7.367-9.472zM7.7 21.75l4.3-5.528 4.3 5.528z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-airplay.js
// module id = null
// module chunks = 